var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan-search" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "8em",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 4 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 10, md: 10 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.searchFilter"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              _vm.searchText = ""
                            },
                          },
                          model: {
                            value: _vm.searchFilter,
                            callback: function ($$v) {
                              _vm.searchFilter = $$v
                            },
                            expression: "searchFilter",
                          },
                        },
                        _vm._l(
                          ["planId", "shipmentReference"],
                          function (item, index) {
                            return _c("el-option", {
                              key: item,
                              attrs: {
                                label: _vm.$t("planning.columns." + item),
                                value: item,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 10, md: 10 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-100" },
                    [
                      _c("el-input", {
                        staticClass: "w-100",
                        attrs: {
                          clearable: "",
                          placeholder: _vm.$t(
                            "planning.placeholder.searchQuery"
                          ),
                        },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 4, md: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.searchTruck },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: "search",
                          "aria-hidden": "true",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }